import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export default async function saveProfile(
	profileType,
	fullName,
	email,
	phoneNumber,
	companyName,
	uid,
	file,
	fileCompany
) {
	if (profileType === 'personal') {
		var userRef = firebaseRef.ref('/users/' + uid);
		var imageUrl;
		console.log('fullNameeee', fullName, email, phoneNumber, uid);

		if (file) {
			console.log('file[0].name', file.name);
			var storage = await firebase
				.storage()
				.ref(
					PROJECT_CODE.projectCode +
						'/users/' +
						uid +
						'/profilePicture/' +
						file.name
				);

			await storage.put(file);
			var storageRef = await firebase
				.storage()
				.ref(
					PROJECT_CODE.projectCode +
						'/users/' +
						uid +
						'/profilePicture/' +
						file.name
				);

			await storageRef.getDownloadURL().then((url) => {
				imageUrl = url;
			});
		}

		console.log('imageUrl', imageUrl);

		if (imageUrl) {
			await userRef.update({
				fullName: fullName,
				displayName: fullName,
				email: email,
				photoURL: imageUrl,
				phoneNumber: phoneNumber ? phoneNumber : '',
			});
		} else {
			await userRef?.update({
				fullName: fullName,
				displayName: fullName,
				email: email,
				phoneNumber: phoneNumber ? phoneNumber : '',
			});
		}
	} else {
		var companyRef = firebaseRef.ref(
			'/kavtek_companies/' + PROJECT_CODE.projectCode
		);
		var imageUrl;

		if (fileCompany) {
			console.log('file[0].name', fileCompany.name);
			var storage = await firebase
				.storage()
				.ref(
					PROJECT_CODE.projectCode +
						'/companyInfo/companyImage/' +
						uid +
						'/' +
						fileCompany.name
				);

			await storage.put(fileCompany);
			var storageRef = await firebase
				.storage()
				.ref(
					PROJECT_CODE.projectCode +
						'/companyInfo/companyImage/' +
						uid +
						'/' +
						fileCompany.name
				);

			await storageRef.getDownloadURL().then((url) => {
				imageUrl = url;
			});
		}

		if (imageUrl) {
			await companyRef.update({
				companyName: companyName,
				companyPictureUrl: imageUrl,
			});
		} else {
			await companyRef.update({
				companyName: companyName,
			});
		}
	}
}
